import IconBackground, { IconBackgroundSizes } from 'components/atoms/IconBackground'
import { colorList } from 'utils/colors'
import { ThemedShared } from 'styles/themed'
import { View } from 'react-native'
import { storeKeys } from 'services/store/keys'
import ThemedPressable from 'components/atoms/ThemedPressable'
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedItem from 'components/atoms/ThemedItem'
import Text from "theme/Text";
import React from 'react'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { listItemAccountStyles } from 'styles/components/atoms/ListItemAccount'

const ListItemAccount = ({ account, isMultiCompanyName = true, isMultiDomain = false, isMultiDomainPrefix = false, currentAccountIdentifier = null, removeAccount = null, switchAccount = () => {
} }) => {
	
	const icon = (
		<IconBackground
			colourfull
			iconSize={ IconBackgroundSizes.S }
			linearGradientColours={ [ colorList.WHITE.primary, colorList.WHITE.dark ] }
			containerStyle={ ThemedShared.borderRadius }>
			
			<View
				style={ listItemAccountStyles.buttonIconIconContainer }>
				
				<Icon
					icon={ IconSystemConstants.PERSON }
					style={ listItemAccountStyles.icon }
				/>
			</View>
		</IconBackground>
	);
	
	let deleteButton = null;
	if( removeAccount !== null && account[ storeKeys.ACCOUNT_IDENTIFIER ] !== currentAccountIdentifier ) {
		deleteButton = (
			<ThemedPressable
				onPress={ event => {
					event.stopPropagation();
					removeAccount( account );
				} }>
				
				<Icon
					icon={ IconSystemConstants.TRASH}
					color={ colorList.RED.primary }
				/>
			</ThemedPressable>
		);
	}
	
	return(
		<ThemedBlock
			shadow>
			
			<ThemedPressable
				style={ listItemAccountStyles.row }
				onPress={ switchAccount.bind( this, account ) }>
				
				<ThemedItem
					style={ listItemAccountStyles.row }
					accessoryLeft={ icon }
					accessoryLeftSize={ 50 }
					actionItem={ deleteButton }>
					
					<View>
						<Text
							style={ listItemAccountStyles.employeeName }>
							
							{ isMultiCompanyName && `${ account[ storeKeys.COMPANY_NAME ] } - ` }
							
							{ account[ storeKeys.EMPLOYEE_NAME ] }
						</Text>
						
						{ (isMultiDomain || isMultiDomainPrefix) && (
							<Text
								style={ listItemAccountStyles.domain }>
								
								{ account[ storeKeys.DOMAIN_PREFIX ] } { account[ storeKeys.DOMAIN ] }
							</Text>
						)}
					</View>
				</ThemedItem>
			</ThemedPressable>
		</ThemedBlock>
	);
}

export default React.memo( ListItemAccount )
